// auto-generated by bin/genVersion.ts
export const VERSION = '1.13.2';
//# sourceMappingURL=version.js.map